import * as React from 'react';
import { TiptapButton } from '../../TiptapButton';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTableColumns } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const ToggleTableHeaderButton = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleHeaderCell().run()}
         isDisabled={!editor.can().toggleHeaderCell()}
         icon={<FontAwesomeIcon icon={faTableColumns} />}
         title={_js('Toggle Header')}
      ></TiptapButton>
   );
};
